import styled from 'styled-components'
import { BLACK, GRADIENT_SELECTED_OVERLAY } from '../../styles/colors'
import { GIVONIC } from '../../styles/fonts'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 18px;
  background: ${GRADIENT_SELECTED_OVERLAY};
`

export const TopRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

export const Title = styled.span`
  font-family: ${GIVONIC.bold};
  font-size: 24px;
  color: ${BLACK};
`
